import {Map, fromJS, List} from "immutable";

import {
    GET_EMPLOYEES_SUCCESS,
    GET_EMPLOYEES_REQUEST,
    GET_EMPLOYEES_ERROR,
    GET_EMPLOYEE_REQUEST,
    GET_EMPLOYEE_SUCCESS,
    GET_EMPLOYEE_ERROR,
    CREATE_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_SUCCESS,
    CREATE_EMPLOYEE_ERROR,
    UPDATE_EMPLOYEE_REQUEST,
    UPDATE_EMPLOYEE_SUCCESS,
    UPDATE_EMPLOYEE_ERROR,
    CHANGE_STATUS_EMPLOYEE_REQUEST,
    CHANGE_STATUS_EMPLOYEE_SUCCESS,
    CHANGE_STATUS_EMPLOYEE_ERROR,
    UPLOAD_EMPLOYEE_FILES_REQUEST,
    UPLOAD_EMPLOYEE_FILES_PROGRESS,
    UPLOAD_EMPLOYEE_FILES_SUCCESS,
    UPLOAD_EMPLOYEE_FILES_ERROR,
    DELETE_EMPLOYEE_FILE_REQUEST,
    DELETE_EMPLOYEE_FILE_SUCCESS,
    DELETE_EMPLOYEE_FILE_ERROR,
    DELETE_EMPLOYEE_REQUEST,
    DELETE_EMPLOYEE_SUCCESS,
    DELETE_EMPLOYEE_ERROR,
    CLEAN_EMPLOYEES
} from '../actions/employees';

const employees = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_EMPLOYEES_REQUEST:
      case GET_EMPLOYEE_REQUEST:
      case CREATE_EMPLOYEE_REQUEST:
      case UPDATE_EMPLOYEE_REQUEST:
      case CHANGE_STATUS_EMPLOYEE_REQUEST:
      case DELETE_EMPLOYEE_FILE_REQUEST:
      case DELETE_EMPLOYEE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_EMPLOYEE_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_EMPLOYEE_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_EMPLOYEES_SUCCESS:
      case GET_EMPLOYEE_SUCCESS:
      case CLEAN_EMPLOYEES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_EMPLOYEE_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_EMPLOYEE_SUCCESS:
      case CHANGE_STATUS_EMPLOYEE_SUCCESS:
      case UPLOAD_EMPLOYEE_FILES_SUCCESS:
      case DELETE_EMPLOYEE_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_EMPLOYEE_SUCCESS:
          updatedPayload = payload.filter( employee => {
              return employee.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_EMPLOYEES_ERROR:
      case GET_EMPLOYEE_ERROR:
      case CREATE_EMPLOYEE_ERROR:
      case UPDATE_EMPLOYEE_ERROR:
      case CHANGE_STATUS_EMPLOYEE_ERROR:
      case UPLOAD_EMPLOYEE_FILES_ERROR:
      case DELETE_EMPLOYEE_FILE_ERROR:
      case DELETE_EMPLOYEE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default employees;



// WEBPACK FOOTER //
// ./src/reducers/employees.js